import {
  arriveatdropof,
  arriveAtPickup,
  finishorderdelivery,
  getOrderById,
  pickuporder,
  StartOrderDelivery,
  startPickupTrip,
} from "services/order";

const handleOrderAction = async ({
  row,
  setSnackbarDetails,
  queryClient,
  action,
  successMessage,
  errorMessage,
}) => {
  try {
    const orderDetails = await getOrderById(row.id);
    const orderId = orderDetails.id;
    const driverId = orderDetails.driverId;

    await action(orderId, driverId);

    queryClient.invalidateQueries(["orders"]);
    queryClient.invalidateQueries(["orderDetails", orderId]);

    setSnackbarDetails({
      message: successMessage,
      severity: "success",
    });
  } catch (error) {
    console.error(error);

    setSnackbarDetails({
      message: errorMessage,
      severity: "error",
    });
  }
};

export const orderActionsMap = (t, openModal) => ({
  [t("pendingPickup")]: [
    {
      label: t("requestDriverChange"),
      onClick: (row) => openModal("driverChangeRequest", row),
    },
    {
      label: t("nextSteppickupstarted"),
      onClick: (row, setSnackbarDetails, queryClient) =>
        handleOrderAction({
          row,
          setSnackbarDetails,
          queryClient,
          action: startPickupTrip,
          successMessage: t("pickuptripstartedsuccessfully"),
          errorMessage: t(
            "actionnotallowedThedrivercurrentlyhasanotheractiveorder"
          ),
        }),
    },
  ],
  [t("pickUpStarted")]: [
    {
      label: t("requestDriverChange"),
      onClick: (row) => openModal("driverChangeRequest", row),
    },
    {
      label: t("nextStepArrivedAtPickup"),
      onClick: (row, setSnackbarDetails, queryClient) =>
        handleOrderAction({
          row,
          setSnackbarDetails,
          queryClient,
          action: arriveAtPickup,
          successMessage: t("successfullyarrivedatpickup"),
          errorMessage: t("Failed to arrive at pickup."),
        }),
    },
  ],
  [t("arrivedAtPickup")]: [
    {
      label: t("requestDriverChange"),
      onClick: (row) => openModal("driverChangeRequest", row),
    },
    {
      label: t("nextStepCollected"),
      onClick: (row, setSnackbarDetails, queryClient) =>
        handleOrderAction({
          row,
          setSnackbarDetails,
          queryClient,
          action: pickuporder,
          successMessage: t("ordercollectedsuccessfully"),
          errorMessage: t("failedtocollectorder"),
        }),
    },
  ],
  [t("rescheduled")]: [
    {
      label: t("nextStepOutForDelivery"),
      onClick: (row, setSnackbarDetails, queryClient) =>
        handleOrderAction({
          row,
          setSnackbarDetails,
          queryClient,
          action: StartOrderDelivery,
          successMessage: t("orderisoutfordelivery"),
          errorMessage: t("failedtostartdelivery"),
        }),
    },
  ],
  [t("orderCollected")]: [
    {
      label: t("requestDriverChange"),
      onClick: (row) => openModal("driverChangeRequest", row),
    },
    {
      label: t("delay"),
      onClick: (row) => openModal("delay", row),
    },
    {
      label: t("nextStepOutForDelivery"),
      onClick: (row, setSnackbarDetails, queryClient) =>
        handleOrderAction({
          row,
          setSnackbarDetails,
          queryClient,
          action: StartOrderDelivery,
          successMessage: t("orderisoutfordelivery"),
          errorMessage: t("failedtostartdelivery"),
        }),
    },
  ],
  [t("orderOutForDelivery")]: [
    {
      label: t("requestDriverChange"),
      onClick: (row) => openModal("driverChangeRequest", row),
    },
    {
      label: t("delay"),
      onClick: (row) => openModal("delay", row),
    },
    {
      label: t("nextStepArrivedAtDropoff"),
      onClick: (row, setSnackbarDetails, queryClient) =>
        handleOrderAction({
          row,
          setSnackbarDetails,
          queryClient,
          action: arriveatdropof,
          successMessage: t("successfullyarrivedatdropoff"),
          errorMessage: t("failedtoarriveatdropoff"),
        }),
    },
  ],
  [t("arrivedAtDropOff")]: [
    {
      label: t("delay"),
      onClick: (row) => openModal("delay", row),
    },
    {
      label: t("reject"),
      onClick: (row) => openModal("reject", row),
    },
    {
      label: t("deliveryFailure"),
      onClick: (row) => openModal("deliveryFailure", row),
    },
    {
      label: t("nextStepDelivered"),
      onClick: (row, setSnackbarDetails, queryClient) =>
        handleOrderAction({
          row,
          setSnackbarDetails,
          queryClient,
          action: finishorderdelivery,
          successMessage: t("orderdeliveredsuccessfully"),
          errorMessage: t("failedtodeliverorder"),
        }),
    },
  ],
});
